import type { ActivityLogItem } from "@memorang/ui/components/Cme/ActivityLogListItem";
import type { CmeTypeOption } from "@memorang/ui/components/Cme/CMETypeSelector";
import type { ExportMethodOption } from "@memorang/ui/components/Cme/ExportMethodSelector";

export const CME_TYPES: CmeTypeOption[] = [
	{
		id: "physician",
		title: "Physician",
		subtitle: "AMA PRA Category 1 Credit",
		icon: "certificate-outline",
	},
	{
		id: "non-physician",
		title: "Non Physician",
		subtitle: "AMA PRA Category 1 Credit",
		icon: "medical-bag",
	},
];

export const getExportMethods = (toEmail: string): ExportMethodOption[] => [
	{
		id: "pdf",
		title: "PDF",
		subtitle: "Download as PDF",
		icon: "file-pdf-box",
	},
	{
		id: "email",
		title: "Email",
		subtitle: `Send to ${toEmail}`,
		icon: "email-outline",
	},
];

// TODO: backed by mock data until the CME activity-log endpoint is confirmed live.
export const mockCmeSummary = {
	earnedCredits: 2.5,
	remainingCredits: 3,
};

export const mockActivityLog: ActivityLogItem[] = [
	{
		title: "+1.5 CME • 9 challenges • Jun 1 - Jun 15",
		subtitle: "Credits earned",
		earned: true,
		score: 1.5,
		distribution: [100],
	},
	{
		title: "Cardiology • 6 challenges",
		subtitle: "Credits remaining",
		earned: false,
		score: 60,
		distribution: [60, 40],
	},
	{
		title: "+1 CME • 6 challenges • May 10 - May 24",
		subtitle: "Credits earned",
		earned: true,
		score: 1,
		distribution: [100],
	},
];

export const cmeDisclaimerDialogConfig = {
	title: "Earn CME!",
	body: "This app provides you with the ability to earn _**AMA PRA Category 1**_ CME credits. Every 3 challenges you successfully complete is worth _**0.25**_ credits. Redeem your credits from the _**CME**_ tab by exporting your certificate and self-reporting.",
	confirmCta: "Learn more",
	dismissCta: "Close",
	icon: "certificate-outline" as const,
};

// Placeholder accreditation copy — replace with the real per-partner
// accreditation body/logo before this export ships to a partner.
export const cmeCertificateInfo = {
	activityTitle: "Image Challenge",
	creditName: "AMA PRA Category 1 credits™",
	logoUrl: "",
	infoText:
		"This organization is accredited to provide continuing medical education.",
	companyAddress: "",
};
